import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Chip from "@material-ui/core/Chip";
import IconButton from "@material-ui/core/IconButton";
import LaunchIcon from "@material-ui/icons/Launch";

const useStyles = makeStyles(() => ({
  chip: {
    fontSize: "x-small",
    marginLeft: 10,
    color: "white",
  },
  tags: {
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    alignItems: "center",
  },
}));

export default function NewsCard({ news }) {
  const classes = useStyles();
  const getDate = (d) => {
    const date = new Date(d);
    const amOrPm = date.getHours() < 12 ? "am" : "pm";
    return (
      date.getDate() +
      "/" +
      (date.getMonth() + 1) +
      "/" +
      date.getFullYear() +
      " at " +
      date.getHours() +
      ":" +
      date.getMinutes() +
      amOrPm
    );
  };

  //console.log("news: ", news);

  return (
    <Grid item sm={4} xs={10} key={news.id}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h6" color="primary">
            {news.source.title}
          </Typography>
          <Typography variant="subtitle2" color="secondary">
            {news.slug}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Published at:{" "}
            <span className={"light"}>{getDate(news.created_at)}</span>
          </Typography>
          <div className={classes.tags}>
            {news.currencies.length > 0 &&
              news.currencies
                .slice(0, 4)
                .map((curr) => (
                  <Chip
                    label={curr.code}
                    color="secondary"
                    className={classes.chip}
                  />
                ))}
            <IconButton
              color="primary"
              component="a"
              href={news.url}
              target="_blank"
            >
              <LaunchIcon fontSize="small" />
            </IconButton>
          </div>
        </CardContent>
      </Card>
    </Grid>
  );
}
